<template>
  <div class="configPage">
    <el-form :model="SearchForm" inline>
      <el-form-item :label="$t('public.time')">
        <el-date-picker
          v-model="time"
          type="datetimerange"
          :start-placeholder="$t('public.start_date')"
          :end-placeholder="$t('public.end_date')"
          @change="changeTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-button icon="el-icon-refresh" @click="reastFn"></el-button>
      <el-button icon="el-icon-search" @click="searchFn"></el-button>
    </el-form>
    <div class="searchContent">
      <div
        v-for="item in SearchArray"
        :key="item.key"
        style="margin-right: 15px;"
      >
        <span class="searchName">{{ $t(item.name) }}</span>
        <span class="searchValue">{{ item.value }}</span>
      </div>
    </div>
    <div class="tablePage">
      <el-table
        stripe
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        :tree-props="{
          children: 'responseDeviceConfigLogList',
          hasChildren: 'hasChildren'
        }"
        row-key="id"
        :height="maxHeight"
        :show-header="false"
      >
        <el-table-column prop="createTime" show-overflow-tooltip>
          <template #default="{ row }">
            <span>{{ $timetransition(row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" show-overflow-tooltip>
          <template #default="{ row }">
            <span class="lineHeight40">{{ typeFn(row.type) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" show-overflow-tooltip>
          <template #default="{ row }">
            <span>{{
              row.stepCode
                ? $t(configStep[row.stepCode].title)
                : statusFn(row.status)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="optare" width="100">
          <template #default="{ row }">
            <el-button
              type="text"
              size="small"
              :title="$t('public.details')"
              icon="el-icon-tickets"
              @click="detailFn(row)"
            ></el-button>
            <el-button
              type="text"
              v-show="row.responseDeviceConfigLogList"
              size="small"
              icon="el-icon-delete"
              :title="$t('public.tbopt_delete')"
              @click="delFn(row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        class="pagination"
        :page.sync="SearchForm.startRecord"
        :limit.sync="SearchForm.maxRecords"
        :total="total"
        @pagination="getLogListFn"
      ></Pagination>
    </div>
    <!-- 命令详情 -->
    <cmdDialog
      :title="title"
      :isShow.sync="isShow"
      :cmdObj="cmdObj"
      :configText="configText"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import cmdDialog from './CmdDialog.vue'
import {
  delConifg,
  getConfigContent,
  getConfigLogContent,
  getConfiglogList
} from '@/api/modules/deviceUrl.js'
import { configStatusConvert, configStep } from '@/utils/convert'
import { ENUM_RE_SENSOR_CONFIG_TYPE } from '@/common/enum/reverse/device'

export default {
  computed: {
    configStep () {
      return configStep
    }
  },
  props: ['rowData'],
  components: {
    cmdDialog
  },
  data () {
    return {
      total: 0,
      maxHeight: '400px',
      SearchForm: {
        devId: '',
        devType: 2, // 设备目录 0-传感器,1-网关,2-显示屏,3-中继
        startTime: '',
        endTime: '',
        startRecord: 0,
        maxRecords: 15
      },
      time: [],
      SearchArray: [
        {
          key: 'name',
          name: 'device.display_name',
          value: ''
        }
      ],
      tableData: [],

      configText: '',
      isShow: false,
      title: '',
      cmdObj: {}
    }
  },
  activated () {
    this.SearchArray[0].value = this.rowData.name
    // this.SearchForm.displayId = this.rowData['id'];
    this.getLogListFn()
  },
  methods: {
    getLogListFn () {
      this.SearchForm.devId = this.rowData.id
      getConfiglogList(this.SearchForm, 'display')
        .then(({ result, state }) => {
          if (state.code === 200) {
            this.tableData = result.page.result
            this.total = result.page.pageInfo.total
            this.time = [
              this.$timetransition(result.startTime),
              this.$timetransition(result.endTime)
            ]
            if (!this.SearchArray[1]) {
              this.SearchArray.push({
                key: 'time',
                name: 'public.time',
                value:
                  this.$timetransition(result.startTime) +
                  '-' +
                  this.$timetransition(result.endTime)
              })
              this.SearchForm.form = result.startTime
              this.SearchForm.to = result.endTime
            }
          }
        })
        .catch(() => {
          this.tableData = []
        })
    },
    changeTime (time) {
      this.SearchForm.form = this.$dateParseTime(new Date(time[0]))
      this.SearchForm.to = this.$dateParseTime(new Date(time[1]))

      this.SearchArray[1].value = time[0] + '-' + time[1]
    },
    reastFn () {
      if (this.SearchArray.length > 1) {
        this.SearchArray.pop()
      }
      ;(this.SearchForm.form = ''), (this.SearchForm.to = '')
      this.time = []
    },
    searchFn () {
      this.getLogListFn()
    },
    typeFn (type) {
      if (!type) return '--'
      return this.$t(ENUM_RE_SENSOR_CONFIG_TYPE[type].title)
    },
    statusFn (status) {
      return this.$t(configStatusConvert(status).title)
    },
    carrierFn (carrierName) {
      if (!carrierName) return
      const array = carrierName.split(',')
      return array
        .map(item => {
          const newArray = item.split('-')
          return newArray[newArray.length - 1]
        })
        .join(',')
    },
    detailFn (row) {
      const str = this.$t(ENUM_RE_SENSOR_CONFIG_TYPE[row.type].title)

      this.isShow = true
      this.title = `[${row.deviceName}][${str}]${$t(
        $t('integration.configuration_details')
      )}-[${this.$timetransition(row.createTime)}]`
      let param = ''
      let httpUrl = ''
      row.responseDeviceConfigLogList
        ? (param = 'configId')
        : (param = 'configLogId')
      row.responseDeviceConfigLogList
        ? (httpUrl = getConfigContent)
        : (httpUrl = getConfigLogContent)
      const query = {
        [param]: row.id
      }

      httpUrl(query, 'display').then(({ result }) => {
        if (result) {
          if (param === 'configId') {
            const JsonContent = JSON.parse(result.deviceConfig.content)
            let url = this.rowData.scopeName
            if (this.rowData.sceneName) {
              url += `-[${this.rowData.sceneName}]`
            }
            this.cmdObj = {
              url: url,
              name: this.rowData.name,
              displayCode: this.rowData.displayCode,
              configStatus: this.rowData.configStatus,
              type: this.rowData.type,
              carrierName: this.carrierFn(this.rowData.carrierName),
              typeWay: row.type, // 区分是上报还是网络
              step: result.stepCode,
              cmd: JsonContent.cmd,
              ...JsonContent.item
            }
          } else {
            const JsonContent = JSON.parse(JSON.parse(result.content).content)
            let url = this.rowData.scopeName
            if (this.rowData.sceneName) {
              url += `-[${this.rowData.sceneName}]`
            }
            this.cmdObj = {
              url: url,
              name: this.rowData.name,
              displayCode: this.rowData.displayCode,
              configStatus: this.rowData.configStatus,
              type: this.rowData.type,
              carrierName: this.carrierFn(this.rowData.carrierName),
              typeWay: row.type, // 区分是上报还是网络
              step: result.stepCode,
              cmd: JsonContent.cmd,
              ...JsonContent.item
            }
          }
        }
      })
      // let JsonContent = '';
      // let step;
      // if (row.content) {
      //   JsonContent = JSON.parse(row.content)
      //   console.log('JsonContent==>', JsonContent);
      //   if (JsonContent.content) {
      //     step = row.stepCode;
      //     JsonContent = JSON.parse(JsonContent.content);
      //     console.log('JsonContent2==>', JsonContent);
      //   }
      // }
      // // const JSONCONTENT = JSON.parse(JsonContent.content);
      // const { cmd, item } = JsonContent;
      // this.cmdObj = Object.assign({}, this.rowData, {
      //   cmd,
      //   extPanId: item['extPanId'],

      //   channelPage: item['channelPage'],

      //   inNetInterval: item['inNetInterval'],

      //   transmitPower: item['transmitPower'],

      //   channelMask: item['channelMask'],
      //   step,
      // })
      // this.configText = row.type;
      // let str = row.type === 'net' ? 'public.net_param' : $t('integration.rule_escalation')
      // this.isShow = true;
      // this.title = `[${row.deviceName}][${str}]配置详细-[${this.$timetransition(row.createTime)}]`
    },
    delFn (row) {
      this.$confirm(
        this.$t('messageTitle.DeleteToContinue'),
        this.$t('public.prompt'),
        {
          confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
          type: 'warning'
        }
      )
        .then(() => {
          delConifg({ configId: row.id }, 'display').then(({ state }) => {
            if (state.code === 200) {
              this.$message.success($t('integration.successfully_deleted'))
              this.getLogListFn()
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.configPage {
  ::v-deep .el-button {
    background-color: #fff !important;
    margin-right: 0;

    i {
      color: var(--primary-color);
    }
  }

  .searchContent {
    height: 50px;
    width: 100%;
    border: 1px solid #ccc;
    box-sizing: border-box;
    border-radius: 2px;
    line-height: 50px;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 15px;
  }

  .tablePage {
    border: 1px solid #ccc;
    box-sizing: border-box;
    padding: 15px;
    min-height: 300px;
  }

  .searchName,
  .searchValue {
    background-color: var(--primary-color);
    padding: 5px;
    border-radius: 2px;
    color: #fff;
  }

  .searchValue {
    background-color: #fff;
    border: 1px solid #ccc;
    color: var(--primary-color);
    border-left: none;
    border-radius: 2px;
  }

  .lineHeight40 {
    line-height: 40px;
  }

  .pagination {
    padding-top: 0;
    padding-right: 15px !important;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
